module.exports = __webpack_public_path__ + "img/icon_new.74dc4011.svg";